import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@base/material';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DirectivesModule } from '@directives/directives.module';

import { ApplicationHttpClient, applicationHttpClientCreator } from '@base/http-client';
import { TableauDashboardComponent } from '@base/tableau-dashboard/tableau-dashboard.component';
import { TableauWorkbookComponent } from '@base/tableau-dashboard/tableau-workbooks/tableau-workbooks.component';
import { TableauWorkbookViewComponent } from '@base/tableau-dashboard/tableau-workbook-view/tableau-workbook-view.component';
import { TableauImageComponent } from '@base/tableau-dashboard/tableau-image/tableau-image.component';
import { TableauViewsComponent } from '@base/tableau-dashboard/tableau-views/tableau-views.component';

@NgModule({
  declarations: [
    TableauDashboardComponent,
    TableauWorkbookComponent,
    TableauWorkbookViewComponent,
    TableauImageComponent,
    TableauViewsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RouterModule,
  ],
  exports: [
    TableauDashboardComponent,
    TableauWorkbookComponent,
    TableauWorkbookViewComponent,
    TableauImageComponent,
    TableauViewsComponent,
  ],
  providers: [
    {
      provide: ApplicationHttpClient,
      useFactory: applicationHttpClientCreator,
      deps: [HttpClient]
    },
  ],
})
export class TableauDashboardModule { }
